import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, isAdmin, loading } = useAuth();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    //wait for initial auth loading to complete
    if (!loading) setReady(true);
  }, [loading]);

  if (!ready) {
    return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center justify-center py-16">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;


  // Render children if user is authenticated and is admin
  return children;
};

export default AdminRoute;


